import React from 'react';
import { Button, Content, Modal, ModalBody, ModalFooter, ModalHeader } from '@patternfly/react-core';

interface NetworkActionComingSoonModalProps {
  actionLabel: string | null;
  onClose: () => void;
}

function NetworkActionComingSoonModal({ actionLabel, onClose }: NetworkActionComingSoonModalProps) {
  const isOpen = actionLabel !== null;
  const title = actionLabel !== null ? `${actionLabel} — coming soon` : '';

  return (
    <Modal variant="small" isOpen={isOpen} onClose={onClose} aria-label="Action coming soon">
      <ModalHeader title={title} />
      <ModalBody>
        <Content>
          Editing networks is not available yet. Networks are managed in NetBox and are read-only here for now.
        </Content>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default NetworkActionComingSoonModal;
